// Modules
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
// Application
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'
import { customLayoutKeys } from 'redesign/constants/customLayout'
import { getQueryParamsValue } from 'utils'
import { CustomLayoutType, ICustomLayoutValue, customLayoutKeysType } from 'redesign/typings/customLayout'

type customLayoutGroupType = {
    [key: string]: CustomLayoutType
}

export const useCustomLayout = (): ICustomLayoutValue => {
    const { getConfigByName } = useRemoteConfig()
    const location = useLocation()
    const customLayouts = (getConfigByName('AUTH_CUSTOM_LAYOUTS') as unknown) as customLayoutGroupType
    const layoutConfig = useMemo(() => {
        let customResult: CustomLayoutType | undefined
        Object.keys(customLayouts).forEach((key: string) => {
            // eslint-disable-next-line prefer-destructuring
            const param = customLayouts?.[key]?.paramKey
            const customKey = getQueryParamsValue(location, param) || ''
            // eslint-disable-next-line prefer-destructuring
            customResult = customLayouts[customKey]
            return customLayouts[customKey]
        })
        return customResult
    }, [customLayouts, location])

    const activeLayout = (useMemo(
        () => ({
            [customLayoutKeys.default]: !layoutConfig,
            [customLayoutKeys.mobileService]: layoutConfig?.layout === customLayoutKeys.mobileService,
        }),
        [layoutConfig],
    ) as unknown) as customLayoutKeysType

    const activeLoginPage = (useMemo(
        () => ({
            [customLayoutKeys.default]: !layoutConfig,
            [customLayoutKeys.mobileService]: layoutConfig?.loginPage === customLayoutKeys.mobileService,
        }),
        [layoutConfig],
    ) as unknown) as customLayoutKeysType

    return {
        layoutConfig,
        activeLayout,
        activeLoginPage,
    }
}
